import { Row, Col, Card, Divider, Image, Typography, Badge } from "antd";
import { Skeleton, Switch, Avatar } from 'antd';

import React, { useEffect, useState } from "react";
import { EditOutlined, EllipsisOutlined, SettingOutlined, EnvironmentOutlined} from '@ant-design/icons';
import { Route, useParams, useRouteMatch } from "react-router";
import { Link } from "react-router-dom";
import Text from "antd/lib/typography/Text";

const { Meta } = Card;
const { Title } = Typography;
const Venues = () => {
    
    let match = useRouteMatch();
    const [loading, setLoading] = useState(true);
    const [venues, setVenues] = useState(null);
   
        useEffect(() => {
            if(loading == true){
                fetch('https://api.arynews.tv/sports/venues.php')
                .then(response => response.json())
                .then(data => {
                    setVenues(data);
                    //alert(data);
                    setLoading(false);
                });

            
            }
            
        });
    
    return(
        <>
            {loading == false && (
                <Row gutter={16}>
                    {venues.map(( item, key ) => 
                        <Card
                                className="venues"
                                style={{ width: 300, margin: 10 }}
                                cover={
                                <img
                                    alt={item.venue_title}
                                    src={item.venue_image_art}
                                />
                                }
                                actions={[
                                <Text style={{ fontSize: 13, fontWeight: 'bold', fontStyle: 'italic', color: "blue" }}> Capacity: {item.venue_capacity}</Text>,
                                <Text style={{ fontSize: 13, fontWeight: 'bold', fontStyle: 'italic', color: "red"}}> Staged: {item.venue_capacity}</Text>,
                                ]}
                            >
                                
                                <h4 style={{ position: 'relative', top: -30,  display: 'initial', padding: 6, fontSize: 15, fontWeight: 'bold', background: 'blue', color: "white" }}><EnvironmentOutlined key="ellipsis" style={{ color: 'red', fontSize: 20 }} title="LOCATION" /> {item.venue_short_city}</h4>
                                <br/>
                                <h3 style={{ textAlign: 'center', fontWeight: 'bold', fontSize: 18 }}> {item.venue_title}</h3>
                            </Card>
                        
                    
                )}
                </Row>
                
            )}
        
        </>       
        
    );
}

function Topic() {
    let { topicId } = useParams();
    return <h3>Requested topic ID: {topicId}</h3>;

}

export default Venues;